import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(email, password);
      navigate('/');
    } catch (err: any) {
      setError(err?.response?.data?.error || err?.message || 'Unable to sign in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0F1923',
    }}>
      <div style={{ width: '100%', maxWidth: 420, padding: 24 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <img src="/logo-white.png" alt="McMullen Browne" style={{ height: 60, marginBottom: 12 }} />
          <p style={{ color: '#4A7EB5', fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', marginTop: 8 }}>Field CRM</p>
        </div>

        <div style={{ background: '#1A2B3C', borderRadius: 16, padding: 32, border: '1px solid #2D4259' }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 24, color: '#fff' }}>Sign In</h2>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#8FA8C0', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                style={{
                  width: '100%', padding: '12px 14px', borderRadius: 10,
                  background: '#243447', border: '1px solid #2D4259',
                  color: '#fff', fontSize: 15,
                }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#8FA8C0', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Password"
                required
                style={{
                  width: '100%', padding: '12px 14px', borderRadius: 10,
                  background: '#243447', border: '1px solid #2D4259',
                  color: '#fff', fontSize: 15,
                }}
              />
            </div>

            {error && <p style={{ color: '#EF4444', fontSize: 13, marginBottom: 16 }}>{error}</p>}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: 14, borderRadius: 10,
                background: '#4A7EB5', color: '#fff',
                fontSize: 16, fontWeight: 700,
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', color: '#4A6580', fontSize: 12, marginTop: 20 }}>
          © McMullen Browne Development LLC
        </p>
      </div>
    </div>
  );
}
